// Customer-site root domain, baked at build time like API_BASE_URL.
// Prod builds get protopal.ai (the default); staging builds pass
// VITE_CUSTOMER_ROOT_DOMAIN=staging.protopal.ai so every preview/live
// link the dashboard renders stays inside the staging universe.
// Components must build site URLs through these helpers — a hardcoded
// protopal.ai here sent staging users to prod 404s.
declare const __CUSTOMER_ROOT_DOMAIN__: string;
declare const __THUMBNAIL_BASE_URL__: string;

export const CUSTOMER_ROOT_DOMAIN = __CUSTOMER_ROOT_DOMAIN__;

/** "<sub>.protopal.ai" — display form of a customer site's host. */
export const siteHost = (subdomain: string) => `${subdomain}.${CUSTOMER_ROOT_DOMAIN}`;

/** "https://<sub>.protopal.ai" — link to a live customer site. */
export const siteUrl = (subdomain: string) => `https://${siteHost(subdomain)}`;

/** "https://forge-<buildId>.protopal.ai" — ad-hoc preview of one build. */
export const forgePreviewUrl = (buildId: string) => `https://forge-${buildId}.${CUSTOMER_ROOT_DOMAIN}`;

/** Saved once per completed version, outside the immutable website bundle. */
export const siteThumbnailUrl = (buildId: string) => `${__THUMBNAIL_BASE_URL__}/${encodeURIComponent(buildId)}/preview.jpg`;

/**
 * Same-origin iframe URL for the site preview / visual editor.
 *
 * Path is relative so the SPA nginx (and Vite dev server) can proxy
 * `/api/preview-frame/*` to portal-api. That keeps the iframe document on
 * the dashboard origin — Cloudflare's X-Frame-Options on forge-* hosts
 * cannot block the embed.
 */
export const previewFrameUrl = (buildId: string) =>
  `/api/preview-frame/${encodeURIComponent(buildId)}/`;

/**
 * Same-origin iframe URL for the chat editor.
 * `?editor=1` asks the proxy to inject the click-to-select bridge.
 */
export const editorPreviewFrameUrl = (buildId: string) =>
  `${previewFrameUrl(buildId)}?editor=1`;
